import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';

const NcDmvDrivingRecordDetails = ({ selectedDrivingRecord, }) => {
  const formatMoney = (money) => {
    if (typeof money === 'string') return parseFloat(money).toFixed(2);
    return `${parseFloat(money.value).toFixed(2)} ${money.currencyCode}`;
  };

  const formatDateTime = (dateString) => {
    if (dateString === undefined || dateString === null) return '';
    return moment.unix(dateString / 1000).format('LLLL');
  };

  return (
    <>
      <FieldSet title="Driving Record">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedDrivingRecord.id,
          'Customer ID': selectedDrivingRecord.customerId,
          'External Account Id': selectedDrivingRecord.externalAccountId,
          'External Bill Id': selectedDrivingRecord.externalBillId,
          'Original Bill Balance': formatMoney(selectedDrivingRecord.originalBillBalance_value),
          'Client Reconciled Timestamp': selectedDrivingRecord.clientReconciledTimestamp,
        })}
        />
      </FieldSet>

      <FieldSet title="Transaction">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedDrivingRecord.id,
          'Payment Transaction ID': selectedDrivingRecord.paymentTransactionId,
          'Payment Transaction Line Item ID': selectedDrivingRecord.paymentTransactionLineItemId,
          'Payment Amount': formatMoney(selectedDrivingRecord.paymentAmount),
          'Payment Date': formatDateTime(selectedDrivingRecord.paymentDate.$date),
        })}
        />
      </FieldSet>
    </>
  );
};

export default NcDmvDrivingRecordDetails;

NcDmvDrivingRecordDetails.propTypes = {
  selectedDrivingRecord: PropTypes.instanceOf(Object).isRequired,
};
